var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1996_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 350C271.65 350 350 271.65 350 175C350 78.3502 271.65 0 175 0C78.3502 0 0 78.3502 0 175C0 271.65 78.3502 350 175 350Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 175C350 164.077 348.999 153.387 347.084 143.018L289.892 85.8252L60.1084 269.496L136.324 345.711C148.766 348.519 161.71 350 175 350C271.65 350 350 271.65 350 175Z",
    fill: "#FFA300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.892 269.496H60.1084V121.723L157.539 107.41L289.892 121.723V269.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.892 121.723L175 87.9683V269.496H289.892V121.723Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1084 85.8252H289.892V121.723H60.1084V85.8252Z",
    fill: "#4A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 85.8252H289.892V121.723H175V85.8252Z",
    fill: "#0053BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.832 115.132C86.1048 115.132 91.1899 110.047 91.1899 103.774C91.1899 97.5016 86.1048 92.4165 79.832 92.4165C73.5592 92.4165 68.4741 97.5016 68.4741 103.774C68.4741 110.047 73.5592 115.132 79.832 115.132Z",
    fill: "#A3D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.898 115.132C116.171 115.132 121.256 110.047 121.256 103.774C121.256 97.5016 116.171 92.4165 109.898 92.4165C103.625 92.4165 98.54 97.5016 98.54 103.774C98.54 110.047 103.625 115.132 109.898 115.132Z",
    fill: "#A3D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.294 267.033L175 308.92L123.706 267.033C113.837 258.975 108.188 247.398 108.188 235.238V157.682L175 132.319L241.812 157.682V235.238C241.812 247.398 236.162 258.975 226.294 267.033Z",
    fill: "#1DD882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 308.92L226.294 267.033C236.163 258.975 241.812 247.398 241.812 235.238V157.682L175 132.319V308.92Z",
    fill: "#06B26B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.871 258.452C200.048 258.452 219.648 238.852 219.648 214.675C219.648 190.498 200.048 170.898 175.871 170.898C151.694 170.898 132.094 190.498 132.094 214.675C132.094 238.852 151.694 258.452 175.871 258.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.871 170.898C175.563 170.898 175.307 170.9 175 170.907V258.443C175.307 258.449 175.563 258.451 175.871 258.451C200.048 258.451 219.648 238.852 219.648 214.674C219.648 190.498 200.048 170.898 175.871 170.898Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.123 240.954L146.516 218.347L161.017 203.846L169.123 211.952L193 188.074L207.502 202.575L169.123 240.954Z",
    fill: "#079E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 188.074L175 206.074V235.077L207.501 202.575L193 188.074Z",
    fill: "#057740"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1996_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalSecurity);
export default __webpack_public_path__ + "static/media/ExternalSecurity.4e2b223c8bd8a82730ad6e92de848f7f.svg";
export { ForwardRef as ReactComponent };